<template>
  <section class="container my-5">
    <div class="row align-items-center">
      <!-- Left Half: Text Content -->
      <div class="col-md-6">
        <p>
          HR Maintenance was founded in 2020, and since then, we have proudly served the Pittsburgh area and its surrounding counties.
          With 25 years of experience in plumbing, we specialize in a variety of services, including plumbing, kitchen and bathroom remodeling,
          floor installation, painting, framing, and drywall installation. We offer free estimates and guarantee that we are the most affordable
          remodeling company in the Pittsburgh area. We are fully insured and hold all necessary certifications, including a Remodeling PA License.
        </p>
      </div>

      <!-- Right Half: Bootstrap Carousel with Portrait Image Support -->
      <div class="col-md-6">
        <div id="imageCarousel" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div v-for="(image, index) in images" :key="index" class="carousel-item" :class="{ active: index === 0 }">
              <img :src="image" class="d-block mx-auto carousel-image" alt="HR Maintenance project image" />
            </div>
          </div>

          <!-- Carousel Controls -->
          <button class="carousel-control-prev" type="button" data-bs-target="#imageCarousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#imageCarousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: "Profile",
  data() {
    return {
      images: [
        "/assets/logos/business-logo.png",
        "/assets/authentic/fan.jpg",
        "/assets/authentic/hvac.jpg",
        "/assets/authentic/oscilator.jpg",
        "/assets/authentic/sink2.jpg",
        "/assets/authentic/painting.JPEG",
        "/assets/authentic/finished1.JPEG",
        "/assets/authentic/finished2.JPEG",

      ]
    };
  }
};
</script>

<style scoped>
/* Carousel Image Styling for Portrait Mode */
.carousel-image {
  height: 500px; /* Ensures uniform height */
  width: auto; /* Maintains aspect ratio */
  object-fit: cover; /* Prevents distortion while cropping excess */
  border-radius: 10px;
  max-width: 110%; /* Ensures the image doesn't exceed container */
}

/* Adjust for mobile screens */
@media (max-width: 768px) {
  .carousel-image {
    height: 400px; /* Smaller height for mobile */
    object-fit: contain; /* Shows full image without cropping */
  }
}
</style>
